/**
 * Comparator for chart rows in ascending chronological order.
 * Prefers numeric `sortTime` when present; otherwise parses the `date` display key
 * (`MM/DD`, `MM/DD-HH:mm`, etc.).
 */

/** Distinct fills for vitals charts when multiple devices plot on the same graph */
export const CHART_DEVICE_PALETTE = [
    '#7A6B78',
    'lightgrey',
];

/** Stable device name → color map (sorted names so order does not jump when data refreshes). */
export function buildDeviceColorMap(deviceNames) {
    const sorted = [...deviceNames].sort((a, b) => String(a).localeCompare(String(b)));
    const map = {};
    sorted.forEach((name, i) => {
        map[name] = CHART_DEVICE_PALETTE[i % CHART_DEVICE_PALETTE.length];
    });
    return map;
}

function parseChartDateKey(dateKey) {
    if (!dateKey) return 0;

    const dashIdx = dateKey.indexOf('-');
    const datePart = dashIdx === -1 ? dateKey : dateKey.slice(0, dashIdx);
    const timePart = dashIdx === -1 ? '00:00' : dateKey.slice(dashIdx + 1);
    const [month, day] = datePart.split('/');
    const year = new Date().getFullYear();
    const parsed = new Date(`${year}/${month}/${day} ${timePart}`).getTime();

    return Number.isFinite(parsed) ? parsed : 0;
}

export function sortData(a, b) {
    const aSort = a?.sortTime;
    const bSort = b?.sortTime;

    if (
        typeof aSort === 'number' &&
        typeof bSort === 'number' &&
        !Number.isNaN(aSort) &&
        !Number.isNaN(bSort)
    ) {
        return aSort - bSort;
    }

    return parseChartDateKey(a?.date) - parseChartDateKey(b?.date);
}